import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { GoogleOAuthProvider } from "@react-oauth/google";

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./components/auth/msalConfig";

const root = ReactDOM.createRoot(document.getElementById("root"));
const clientId_google = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const msalInstance = new PublicClientApplication(msalConfig);
function clearStaleMsalInteraction() {
  const stores = [sessionStorage];
  for (const store of stores) {
    Object.keys(store)
      .filter((k) => k.includes("msal") && k.includes("interaction.status"))
      .forEach((k) => store.removeItem(k));
  }
}
// async function bootstrap() {
//   // ✅ Required in newer MSAL versions
//   await msalInstance.initialize();

//   // ✅ MOST IMPORTANT: process redirect result BEFORE rendering React
//   const response = await msalInstance.handleRedirectPromise();

//   // ✅ If redirect login happened, set active account
//   if (response?.account) {
//     msalInstance.setActiveAccount(response.account);
//   } else {
//     // ✅ If no response, still restore session from cache (mobile/iOS)
//     const accounts = msalInstance.getAllAccounts();
//     if (accounts.length > 0) {
//       msalInstance.setActiveAccount(accounts[0]);
//     }
//   }

//   root.render(
//     <React.StrictMode>
//       <GoogleOAuthProvider clientId={clientId_google} ux_mode="popup">
//         <MsalProvider instance={msalInstance}>
//           <App />
//         </MsalProvider>
//       </GoogleOAuthProvider>
//     </React.StrictMode>,
//   );
// }

async function bootstrap() {
  await msalInstance.initialize();
  await msalInstance.handleRedirectPromise();
  try {
    const response = await msalInstance.handleRedirectPromise();

    if (response?.account) {
      msalInstance.setActiveAccount(response.account);
    } else {
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) msalInstance.setActiveAccount(accounts[0]);
    }
  } catch (e) {
    // ✅ handle the exact case you're seeing
    if (e?.errorCode === "hash_empty_error") {
      clearStaleMsalInteraction();
      // continue rendering; user can click login again cleanly
    } else {
      throw e;
    }
  }

  root.render(
    <React.StrictMode>
      <GoogleOAuthProvider clientId={clientId_google} ux_mode="popup">
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </GoogleOAuthProvider>
    </React.StrictMode>,
  );
}

bootstrap().catch((e) => {
  console.error("MSAL bootstrap failed:", e);

  // Render app anyway so user isn't stuck on blank screen
  root.render(
    <React.StrictMode>
      <GoogleOAuthProvider clientId={clientId_google} ux_mode="popup">
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </GoogleOAuthProvider>
    </React.StrictMode>,
  );
});
